import auth0 from 'auth0-js'

class Auth0JS {
  constructor(config) {
    this.webAuth = new auth0.WebAuth({
      domain: config.auth0.domain,
      clientID: config.auth0.clientID,
      redirectUri: config.baseURL,
      responseType: 'id_token',
      scope: 'openid profile email',
    })
    this.config = config
    this.id_token = ''
    this.user = {}
  }

  login(language) {
    if (language) {
      const uiLocales = language === 'zh' ? 'zh-CN' : language
      this.webAuth.authorize({ ui_locales: uiLocales, responseType: 'code', redirectUri: `${this.config.apiURL}/login/auth0` })
    } else {
      this.webAuth.authorize()
    }
  }
  
  signup(lang) {
    const uiLocales = lang === 'zh' ? 'zh-CN' : lang
    this.webAuth.authorize({
      ui_locales: uiLocales,
      screen_hint: 'signup'
    })
  }

  logout(lang) {
    this.webAuth.logout({
      returnTo: `${this.config.baseURL}?${
        lang ? `locale=${lang}&` : ""
      }login=none`, // Allowed logout URL listed in dashboard
      clientID: this.config.auth0.clientID,
    });
  }

  checkSession() {
    return new Promise((resolve, reject) => {
      this.webAuth.checkSession({}, (err, authResult) => {
        if (authResult) {
          this.id_token = authResult.idToken
          this.user = authResult.idTokenPayload
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  if (process.server) return
  const runtimeConfig = useRuntimeConfig();
  
  const auth0JS = new Auth0JS(runtimeConfig.public)
  nuxtApp.provide('auth0JS', auth0JS)
})
